import React from "react";

const blue = "#3677BC";
const ExclusionGroup = ({
  color = blue,
  strokeColor = "#fff",
  viewBox = "0 0 22 22",
  grayscale,
  invertColors,
  width = 20,
  height = 20,
  ...rest
}) => {
  if (grayscale) {
    color = "#b2b2b2";
    strokeColor = "#fff";
  }

  if (invertColors) {
    // swap values of color variables:
    [color, strokeColor] = [strokeColor, color];
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      height={height}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <circle cx="5" cy="5" r="5" fill={color} fillRule="nonzero" />
        <g stroke={strokeColor} strokeLinecap="round" strokeWidth="1.5">
          <path d="M3 3l4 4M7 3L3 7" />
        </g>
        <circle
          cx="5"
          cy="5"
          r="5"
          fill={color}
          fillRule="nonzero"
          transform="translate(12)"
        />
        <g stroke={strokeColor} strokeLinecap="round" strokeWidth="1.5">
          <path d="M15 3l4 4M19 3l-4 4" />
        </g>
        <circle
          cx="5"
          cy="5"
          r="5"
          fill={color}
          fillRule="nonzero"
          transform="translate(12 12)"
        />
        <g stroke={strokeColor} strokeLinecap="round" strokeWidth="1.5">
          <path d="M15 15l4 4M19 15l-4 4" />
        </g>
        <circle cx="5" cy="17" r="5" fill={color} fillRule="nonzero" />
        <g stroke={strokeColor} strokeLinecap="round" strokeWidth="1.5">
          <path d="M3 15l4 4M7 15l-4 4" />
        </g>
      </g>
    </svg>
  );
};

export default ExclusionGroup;
